var bundle = {

    $bundle: $('.bundle'),

    init: function () {
        if (this.$bundle.length <= 0) {
            return;
        }

        this.setListeners();
    },

    setListeners: function () {
        var $this = this;
        this.$bundle.find('[type="checkbox"]').on('change', function () {

            // Mise à jour du total
            $this.updateTotal($this.$bundle);

            // Affichage ou masquage de la vignette du produit updaté
            var idProduct = $(this).val();
            // console.log($(this).is(':checked'));
            // $this.$bundle.find('.line-img .thumb_' + idProduct).toggle($(this).is(':checked'));
            var opacity = ($(this).is(':checked')) ? 1 : 0.2;
            console.log(opacity);
            $this.$bundle.find('.line-img .thumb_' + idProduct).css('opacity', opacity);

        });

        $('.buybox')
            .on('change', 'select.selectVariante', function() {
                if ($(this).val() == '') {
                    $this.$bundle.find('button').attr('disabled', 'disabled');
                    $this.$bundle.find('div#messageError').removeClass('d-none');
                }
                else {
                    $this.$bundle.find('button').removeAttr('disabled');
                    $this.$bundle.find('div#messageError').addClass('d-none');
                }
            });

        if ($('.buybox').find('select.selectVariante').length == 0) {
            $this.$bundle.find('button').removeAttr('disabled');
            $this.$bundle.find('div#messageError').addClass('d-none');
        }


    },

    updateTotal: function ($bundle) {
        var total = 0;

        $.each($bundle.find('[type="checkbox"]:checked'), function (key, value) {
            total += parseFloat($(value).attr('data-price'));
        });

        $bundle.find('.line-price .new-price').html(__('prix_devise', total.toFixed(2)));
    },

};

(function ($) {
    bundle.init();
})(jQuery);